import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from 'rootReducer';
import { useCurrentEvent } from 'features/events/eventHooks';
import { updateEvent } from 'features/events/eventsSlice';
import { updateChatMessage } from 'features/chat/chatSlice';
import ChatComment from './ChatComment';
import { ChatInput } from './ChatInput';
import { ChatMessageModel } from '../ChatMessageModel';

export const PinnedComment: FunctionComponent = () => {
  const event = useCurrentEvent();
  const dispatch = useDispatch();
  const socketId = useSelector((state: RootState) => state.hub.socketId);
  const [isEditing, setIsEditing] = useState(false);

  if (!event || !event.pinnedComment) return null;

  const pinnedComment = event.pinnedComment;
  const comment = ChatMessageModel(pinnedComment);

  const handleUpdate = (text: string) => {
    dispatch(updateChatMessage(comment.id, text, socketId ?? ''));
    dispatch(
      updateEvent({
        id: event.id,
        pinnedComment: { ...pinnedComment, content: text }
      })
    );
    setIsEditing(false);
  };

  return (
    <div className="pinned-comment tw-bg-theme-color !tw-text-white [.light-contrast_&]:!tw-text-black [&_img]:tw-max-h-20 [&_img]:tw-w-auto">
      {isEditing ? (
        <ChatInput
          channelId={null}
          initialContent={comment.content}
          onSubmit={handleUpdate}
          onCancel={() => setIsEditing(false)}
          submitLabel="Save"
        />
      ) : (
        <ul className="tw-list-none tw-m-0 tw-p-0 tw-px-4 tw-pt-2">
          <ChatComment
            key={comment.id}
            id={comment.id}
            comment={comment.content}
            user={comment.display_name}
            userId={comment.user_id}
            date={comment.parsedCreatedAt}
            img={comment.profile_image_url}
            type={comment.type}
            heartScale={comment.heartScale}
            pinned={true}
            onEdit={() => setIsEditing(true)}
          />
        </ul>
      )}
    </div>
  );
};
